import { PropsWithChildren } from 'react';

interface DrillDownProps {
  onClick: () => void
}

export const Drilldown: React.FC<PropsWithChildren<DrillDownProps>> = ({ onClick, children }) => {
  const clickWithoutPropagation = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };
  return (
    <a
      onClick={clickWithoutPropagation}
      className="drilldown-link"
      style={{
        color: '#ffd014',
        fontWeight: 600,
        textDecoration: 'none',
        cursor: 'pointer',
      }}
    >
      {children}
    </a>
  );
};
